import React from 'react'

export default function Footer() {
  let userData = JSON.parse(localStorage.getItem("userData"));
  return (
    <div className="footer">
            <div className="copyright">
              <p>
                Copyright © Developed by{" "}
                <a href="#">
                  {userData?.company_name}
                </a>{" "}
                <span className="current-year">2024</span>
              </p>
            </div>
          </div>
  )
}
